import React, { useState } from 'react';
import './InstagramGallery.css';
import TandemImg from '../assets/tandem_photo.png';
import AffImg from '../assets/aff_photo.png';
import EstaticaImg from '../assets/static_photo.png';
import AvionImg from '../assets/avion.jpeg';
import LogoLeft from '../assets/paracaidismo_logo_left.png';
import LogoRight from '../assets/paracaidismo_logo_right.png';

const photos = [
    { src: TandemImg, alt: 'Salto tándem en paracaídas' },
    { src: AffImg, alt: 'Curso AFF - caída libre' },
    { src: AvionImg, alt: 'Avión de salto' },
    { src: EstaticaImg, alt: 'Salto de línea estática' },
    { src: LogoLeft, alt: 'Paracaidismo en Uruguay' },
    { src: LogoRight, alt: 'Equipo Desafío Extremo' },
];

function InstagramGallery() {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const openPhoto = (index) => setSelectedIndex(index);
    const closePhoto = () => setSelectedIndex(null);

    const goNext = () => setSelectedIndex((prev) => (prev + 1) % photos.length);
    const goPrev = () => setSelectedIndex((prev) => (prev - 1 + photos.length) % photos.length);

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') closePhoto();
        if (e.key === 'ArrowRight') goNext();
        if (e.key === 'ArrowLeft') goPrev();
    };

    return (
        <section id="gallery" className="gallery">
            <h2 className="gallery__title">Galería de Fotos</h2>
            <div className="gallery__grid">
                {photos.map((photo, index) => (
                    <button
                        key={index}
                        className="gallery__item"
                        onClick={() => openPhoto(index)}
                        aria-label={`Ver foto: ${photo.alt}`}
                    >
                        <img
                            src={photo.src}
                            alt={photo.alt}
                            className="gallery__img"
                            loading="lazy"
                        />
                    </button>
                ))}
            </div>

            {selectedIndex !== null && (
                <div
                    className="gallery__lightbox"
                    onClick={closePhoto}
                    onKeyDown={handleKeyDown}
                    role="dialog"
                    aria-label="Visor de fotos"
                    tabIndex={0}
                    ref={(el) => el && el.focus()}
                >
                    <button
                        className="gallery__lightbox-close"
                        onClick={closePhoto}
                        aria-label="Cerrar visor"
                    >
                        &times;
                    </button>
                    <button
                        className="gallery__lightbox-prev"
                        onClick={(e) => { e.stopPropagation(); goPrev(); }}
                        aria-label="Foto anterior"
                    >
                        &#8249;
                    </button>
                    <img
                        src={photos[selectedIndex].src}
                        alt={photos[selectedIndex].alt}
                        className="gallery__lightbox-img"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <button
                        className="gallery__lightbox-next"
                        onClick={(e) => { e.stopPropagation(); goNext(); }}
                        aria-label="Foto siguiente"
                    >
                        &#8250;
                    </button>
                </div>
            )}
        </section>
    );
}

export default InstagramGallery;
